import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import {
  ScenarioName,
  useOnboardingGetProcessByScenarioName,
} from 'api/requests';
import {
  useLegalClientLegalHeadFirstHeadSettingsSave,
  useLegalClientGetLegalHeadFirstHeadLazy,
  useLegalClientCompleteLegalHeadFirstHeadOnboarding,
} from 'api/requests/onboarding/legal/legalHeadFirstHead';
import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
  OnboardingProcessStepNameType,
} from 'api/types/entity';

export const useOnboarding = (
  currentClient: LegalClientRepresentativeEntity,
  legalClient: LegalClientEntity,
  legalHeadId: string,
  firstHeadId?: string
) => {
  const headId = useRef(firstHeadId);
  const [loading, setLoading] = useState(false);

  const { saveSettings } = useLegalClientLegalHeadFirstHeadSettingsSave();

  const { getFirstHead, firstHead } = useLegalClientGetLegalHeadFirstHeadLazy();

  const { complete } = useLegalClientCompleteLegalHeadFirstHeadOnboarding();

  const { process, loading: processLoading } =
    useOnboardingGetProcessByScenarioName(
      ScenarioName.LegalClientLegalHeadFirstHead
    );

  const onGoBack = useCallback(
    async (currentStepName: OnboardingProcessStepNameType) => {
      if (firstHeadId) {
        await saveSettings(
          legalClient.id,
          legalHeadId,
          firstHeadId,
          currentStepName
        );
      }
    },
    [firstHeadId, saveSettings, legalClient.id, legalHeadId]
  );

  const onEnd = useCallback(
    async () => complete(legalClient.id, legalHeadId, firstHeadId!),
    [complete, firstHeadId, legalClient.id, legalHeadId]
  );

  useLayoutEffect(() => {
    if (headId.current) {
      setLoading(true);
      getFirstHead(legalClient.id, legalHeadId, headId.current).finally(() =>
        setLoading(false)
      );
    }
  }, [getFirstHead, legalClient.id, legalHeadId]);

  return {
    currentClient,
    firstHead,
    legalClient,
    loading: loading || (processLoading && !process),
    process,
    getFirstHead,
    onGoBack,
    onEnd,
  };
};
